import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import { translate } from 'i18n/i18n'
import { sortByKey } from 'utils/sortByKey'

export const BlocksSelect = ({ options }: { options: Array<{ value: string; label: string }> }) => {
  const state = dataExportStore.useSelector((s) => s)

  return (
    <div>
      <div css={{ fontSize: 17 }}>{translate.phrases.banyanApp('Blocks')}</div>
      <div css={{ marginTop: 10, marginBottom: 10 }}>
        <MultiSelect
          selectedData={state.formState.blockIds
            .map((blockId) => ({
              value: blockId,
              label: options.find((x) => x.value === blockId)?.label,
              id: blockId,
            }))
            .sort(sortByKey('label'))}
          onChange={(data) => dataExportStore.actions.changeBlockIds(data.map((x) => String(x.value)))}
          data={options}
        />
      </div>
    </div>
  )
}
